import { render, staticRenderFns } from "./ConsultarecibidaGrid.vue?vue&type=template&id=428d151a&scoped=true&"
import script from "./ConsultarecibidaGrid.vue?vue&type=script&lang=js&"
export * from "./ConsultarecibidaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d151a",
  null
  
)

/* custom blocks */
import block0 from "./ConsultarecibidaGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports